import { useContext, useEffect } from 'react';

import { HubConnectionState } from '@microsoft/signalr';

import type { NewDesktopConnected } from 'Courses/data';
import { addParticipant, newDesktopConnected } from 'Courses/data';
import { SignalRConnectionContext, useOnSignalRMethod } from 'SignalR';
import { useAppDispatch } from 'Store';

import type { ParticipantModel } from 'Api';

export const useJoinCourseGroup = (courseId: string) => {
  const { connection, state } = useContext(SignalRConnectionContext);
  const dispatch = useAppDispatch();

  useOnSignalRMethod('NewParticipantConnected', (participant: ParticipantModel) => {
    dispatch(addParticipant({ participant, courseId }));
  });

  useOnSignalRMethod('NewDesktopConnected', (model: NewDesktopConnected) => {
    dispatch(newDesktopConnected({ model, courseId }));
  });

  useEffect(() => {
    if (state !== HubConnectionState.Connected || !courseId) {
      return;
    }

    let isJoined = false;

    const joinCourseGroup = async () => {
      try {
        await connection.invoke('JoinCourseGroup', courseId);
        isJoined = true;
      } catch (error) {
        console.error(`Failed to join course group ${courseId}:`, error);
      }
    };

    const leaveCourseGroup = async () => {
      if (isJoined) {
        try {
          await connection.invoke('LeaveCourseGroup', courseId);
        } catch (error) {
          console.error(`Failed to leave course group ${courseId}:`, error);
        }
      }
    };

    joinCourseGroup();

    return () => {
      leaveCourseGroup();
    };
  }, [connection, courseId, state]);
};
